// Редиректы со старых admin-роутов Academy на единое рабочее пространство.
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

export const CourseViewRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/admin/academy/courses/${id}`} replace />;
};

export const ModuleNewRedirect: React.FC = () => {
  const { courseId } = useParams<{ courseId: string }>();
  return <Navigate to={`/admin/academy/courses/${courseId}`} replace />;
};

export const ModuleEditRedirect: React.FC = () => {
  const { courseId, moduleId } = useParams<{ courseId: string; moduleId: string }>();
  return <Navigate to={`/admin/academy/courses/${courseId}?module=${moduleId}`} replace />;
};
